let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hwS6h")).then(() => parcelRequire('2aaW2'));